import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LogInModal from 'flarum/forum/components/LogInModal';
import PasatiemposLeaderboard from './PasatiemposLeaderboard';
export default class AnagramasGame extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "level", 1);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "hasStarted", false);
    _defineProperty(this, "submitting", false);
    _defineProperty(this, "roundId", '');
    _defineProperty(this, "words", []);
    _defineProperty(this, "currentIndex", 0);
    _defineProperty(this, "wordStates", []);
    // Hints
    _defineProperty(this, "hintsUsedTotal", 0);
    // Timer
    _defineProperty(this, "timerSeconds", 0);
    _defineProperty(this, "timerInterval", null);
    // Auto-advance
    _defineProperty(this, "autoAdvanceTimeout", null);
    // Final result
    _defineProperty(this, "isFinished", false);
    _defineProperty(this, "results", null);
    // Keydown listener
    _defineProperty(this, "boundKeyHandler", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.level = vnode.attrs.level || 1;
    this.startNewRound(this.level);
    this.boundKeyHandler = this.handleKeyDown.bind(this);
    window.addEventListener('keydown', this.boundKeyHandler);
  }
  onremove(vnode) {
    this.stopTimer();
    this.clearAutoAdvance();
    if (this.boundKeyHandler) {
      window.removeEventListener('keydown', this.boundKeyHandler);
    }
    super.onremove(vnode);
  }
  clearAutoAdvance() {
    if (this.autoAdvanceTimeout) {
      clearTimeout(this.autoAdvanceTimeout);
      this.autoAdvanceTimeout = null;
    }
  }
  startTimer() {
    this.stopTimer();
    this.timerSeconds = 0;
    this.timerInterval = setInterval(() => {
      this.timerSeconds++;
      m.redraw();
    }, 1000);
  }
  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }
  startGame() {
    this.hasStarted = true;
    this.startTimer();
    m.redraw();
  }
  selectLevel(lvl) {
    if (lvl === this.level && !this.isFinished) return;
    if (this.hasStarted && !this.isFinished) {
      const ok = confirm('¿Quieres abandonar la tanda actual y cambiar de nivel? No se guardará el progreso.');
      if (!ok) return;
    }
    this.startNewRound(lvl);
  }
  startNewRound(level) {
    this.level = level;
    this.loading = true;
    this.hasStarted = false;
    this.submitting = false;
    this.isFinished = false;
    this.results = null;
    this.currentIndex = 0;
    this.wordStates = [];
    this.hintsUsedTotal = 0;
    this.stopTimer();
    this.clearAutoAdvance();
    m.redraw();
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/anagrams/round?level=' + this.level
    }).then(response => {
      this.roundId = response.round_id;
      this.words = response.words;
      this.initAllWordStates();
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar la ronda de anagramas.');
      m.redraw();
    });
  }
  initAllWordStates() {
    this.wordStates = this.words.map(word => {
      const pattern = word.pattern || new Array(word.length).fill('_').join('');
      const placed = [];
      const used = [];
      for (let i = 0; i < pattern.length; i++) {
        if (pattern[i] === ' ') {
          placed.push(' ');
        } else {
          placed.push('');
        }
      }

      // Si nivel 1 y hay primera letra, fijarla en el primer hueco de letra
      if (this.level === 1 && word.first_letter) {
        const firstSlotIdx = pattern.indexOf('_');
        if (firstSlotIdx !== -1) {
          placed[firstSlotIdx] = word.first_letter;
          const scrambledArr = word.scrambled.split('');
          const foundTileIdx = scrambledArr.findIndex(l => l === word.first_letter);
          if (foundTileIdx !== -1) {
            used.push(foundTileIdx);
          }
        }
      }
      return {
        placedLetters: placed,
        usedTileIndices: used,
        hintRevealed: false,
        skipped: false
      };
    });
  }
  goToWord(idx) {
    if (idx < 0 || idx >= this.words.length) return;
    this.clearAutoAdvance();
    this.currentIndex = idx;
    m.redraw();
  }
  isWordFilled(idx) {
    const word = this.words[idx];
    const state = this.wordStates[idx];
    if (!word || !state) return false;
    const pattern = word.pattern || '';
    for (let i = 0; i < pattern.length; i++) {
      if (pattern[i] === '_' && (!state.placedLetters[i] || state.placedLetters[i].trim() === '')) {
        return false;
      }
    }
    return true;
  }
  isWordCompleted(idx) {
    const state = this.wordStates[idx];
    if (!state || state.skipped) return false;
    return this.isWordFilled(idx);
  }
  countIncompleteWords() {
    let count = 0;
    for (let i = 0; i < this.words.length; i++) {
      if (!this.isWordCompleted(i)) {
        count++;
      }
    }
    return count;
  }
  skipCurrentWord() {
    this.clearAutoAdvance();
    const state = this.wordStates[this.currentIndex];
    if (state) {
      state.skipped = true;
    }
    this.skipToNext();
  }
  skipToNext() {
    this.clearAutoAdvance();
    // Buscar el siguiente león no completado (ni pasado)
    const total = this.words.length;
    for (let step = 1; step <= total; step++) {
      const nextIdx = (this.currentIndex + step) % total;
      if (!this.isWordCompleted(nextIdx)) {
        this.currentIndex = nextIdx;
        m.redraw();
        return;
      }
    }
    // Si todos están completados, avanza al siguiente en ciclo
    this.currentIndex = (this.currentIndex + 1) % total;
    m.redraw();
  }
  handleTileClick(letter, tileIndex) {
    this.clearAutoAdvance();
    const state = this.wordStates[this.currentIndex];
    const word = this.words[this.currentIndex];
    if (!state || !word || state.usedTileIndices.includes(tileIndex)) return;
    const pattern = word.pattern || '';
    const emptySlotIdx = state.placedLetters.findIndex((l, idx) => pattern[idx] === '_' && l === '');
    if (emptySlotIdx === -1) return;
    state.placedLetters[emptySlotIdx] = letter;
    state.usedTileIndices.push(tileIndex);
    m.redraw();

    // Si se han colocado todas las letras del león actual
    if (this.isWordFilled(this.currentIndex)) {
      // Ya que ha rellenado todas las casillas, desmarcar como saltado
      state.skipped = false;
      m.redraw();
      const remaining = this.countIncompleteWords();
      if (remaining > 0) {
        // Saltar al siguiente león incompleto/pendiente
        this.autoAdvanceTimeout = setTimeout(() => {
          this.skipToNext();
          this.autoAdvanceTimeout = null;
        }, 250);
      } else {
        // Todos los leones de la tanda están completos y no hay ninguno marcado como pasado -> enviar tanda automáticamente
        this.autoAdvanceTimeout = setTimeout(() => {
          this.finishRound();
          this.autoAdvanceTimeout = null;
        }, 350);
      }
    }
  }
  handleSlotClick(slotIdx) {
    this.clearAutoAdvance();
    const state = this.wordStates[this.currentIndex];
    const word = this.words[this.currentIndex];
    if (!state || !word) return;
    const pattern = word.pattern || '';
    // No click en espacios
    if (pattern[slotIdx] === ' ') return;

    // En nivel 1, la primera letra es fija
    const firstLetterSlot = pattern.indexOf('_');
    if (this.level === 1 && slotIdx === firstLetterSlot && word.first_letter) {
      return;
    }
    const letter = state.placedLetters[slotIdx];
    if (!letter) return;

    // Quitar letra del slot
    state.placedLetters[slotIdx] = '';

    // Liberar la última ficha usada con esa letra
    const scrambledArr = word.scrambled.split('');
    for (let i = state.usedTileIndices.length - 1; i >= 0; i--) {
      const tileIdx = state.usedTileIndices[i];
      if (scrambledArr[tileIdx] === letter) {
        state.usedTileIndices.splice(i, 1);
        break;
      }
    }
    m.redraw();
  }
  handleKeyDown(e) {
    var _document$activeEleme;
    if (this.loading || this.isFinished || this.submitting) return;
    if (!this.hasStarted) {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.startGame();
      }
      return;
    }

    // Ignorar si el foco está en un input o textarea normal
    if (['INPUT', 'TEXTAREA'].includes(((_document$activeEleme = document.activeElement) == null ? void 0 : _document$activeEleme.tagName) || '')) return;
    const key = e.key.toUpperCase();
    if (key === 'BACKSPACE') {
      e.preventDefault();
      this.removeLastLetter();
      return;
    }
    if (key === 'ENTER') {
      e.preventDefault();
      if (this.isWordCompleted(this.currentIndex)) {
        if (this.countIncompleteWords() === 0) {
          this.promptFinishRound();
        } else {
          this.skipToNext();
        }
      } else {
        this.skipCurrentWord();
      }
      return;
    }
    if (/^[A-ZÑ]$/.test(key)) {
      const word = this.words[this.currentIndex];
      const state = this.wordStates[this.currentIndex];
      if (!word || !state) return;
      const scrambled = word.scrambled.split('');
      const freeTileIdx = scrambled.findIndex((l, idx) => l === key && !state.usedTileIndices.includes(idx));
      if (freeTileIdx !== -1) {
        this.handleTileClick(key, freeTileIdx);
      }
    }
  }
  removeLastLetter() {
    const state = this.wordStates[this.currentIndex];
    const word = this.words[this.currentIndex];
    if (!state || !word) return;
    const pattern = word.pattern || '';
    const firstLetterSlot = pattern.indexOf('_');
    for (let i = state.placedLetters.length - 1; i >= 0; i--) {
      if (pattern[i] === '_') {
        if (this.level === 1 && i === firstLetterSlot && word.first_letter) {
          continue;
        }
        if (state.placedLetters[i] !== '') {
          this.handleSlotClick(i);
          break;
        }
      }
    }
  }
  resetCurrentWord() {
    this.clearAutoAdvance();
    const word = this.words[this.currentIndex];
    if (!word) return;
    const pattern = word.pattern || '';
    const placed = [];
    const used = [];
    for (let i = 0; i < pattern.length; i++) {
      if (pattern[i] === ' ') {
        placed.push(' ');
      } else {
        placed.push('');
      }
    }
    if (this.level === 1 && word.first_letter) {
      const firstSlot = pattern.indexOf('_');
      if (firstSlot !== -1) {
        placed[firstSlot] = word.first_letter;
        const scrambledArr = word.scrambled.split('');
        const foundTileIdx = scrambledArr.findIndex(l => l === word.first_letter);
        if (foundTileIdx !== -1) {
          used.push(foundTileIdx);
        }
      }
    }
    this.wordStates[this.currentIndex].placedLetters = placed;
    this.wordStates[this.currentIndex].usedTileIndices = used;
    this.wordStates[this.currentIndex].skipped = false;
    m.redraw();
  }
  revealHint() {
    const state = this.wordStates[this.currentIndex];
    if (!state || state.hintRevealed) return;
    state.hintRevealed = true;
    this.hintsUsedTotal++;
    m.redraw();
  }
  promptFinishRound() {
    const incompleteCount = this.countIncompleteWords();
    if (incompleteCount > 0) {
      const ok = confirm("Tienes ".concat(incompleteCount, " le\xF3n(es) sin responder por completo en esta tanda.\n\n\xBFQuieres finalizar y enviar la tanda igualmente?"));
      if (!ok) return;
    }
    this.finishRound();
  }
  finishRound() {
    if (this.submitting || this.isFinished) return;
    this.stopTimer();
    this.clearAutoAdvance();
    this.submitting = true;
    m.redraw();
    const answers = this.words.map((word, idx) => {
      const state = this.wordStates[idx];
      return {
        id: word.id,
        answer: state ? state.placedLetters.join('').trim() : ''
      };
    });
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/anagrams/submit',
      body: {
        round_id: this.roundId,
        level: this.level,
        answers: answers,
        duration_seconds: this.timerSeconds,
        hints_used: this.hintsUsedTotal
      }
    }).then(response => {
      try {
        this.results = response || {};
        this.submitting = false;
        this.isFinished = true;
        m.redraw();
      } catch (transitionErr) {
        console.error('[Pasatiempos] Error transitioning to results:', transitionErr);
        this.submitting = false;
        this.isFinished = true;
        m.redraw();
      }
    }).catch(err => {
      var _err$response;
      this.submitting = false;
      const msg = (err == null || (_err$response = err.response) == null ? void 0 : _err$response.error) || (err == null ? void 0 : err.message) || 'Error al validar la tanda.';
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
  formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return "".concat(mins, ":").concat(secs < 10 ? '0' : '').concat(secs);
  }
  renderLevelSelector() {
    const levels = [{
      id: 1,
      name: 'Nivel 1',
      desc: '1º Masc'
    }, {
      id: 2,
      name: 'Nivel 2',
      desc: 'Masc + Fem'
    }, {
      id: 3,
      name: 'Nivel 3',
      desc: 'Lezama'
    }];
    return m("div", {
      className: "anagrams-levels-bar",
      style: {
        marginBottom: '20px',
        width: '100%'
      }
    }, m("div", {
      className: "level-pills",
      style: {
        display: 'flex',
        gap: '8px',
        justifyContent: 'center',
        width: '100%'
      }
    }, levels.map(lvl => {
      const isActive = this.level === lvl.id;
      return m("button", {
        key: lvl.id,
        className: "level-pill ".concat(isActive ? 'active' : ''),
        onclick: () => this.selectLevel(lvl.id),
        style: {
          flex: '1 1 0',
          padding: '8px 4px',
          borderRadius: '24px',
          border: isActive ? '2px solid #d52b1e' : '1px solid #cbd5e1',
          background: isActive ? '#d52b1e' : '#ffffff',
          color: isActive ? '#ffffff' : '#334155',
          cursor: 'pointer',
          boxShadow: isActive ? '0 3px 10px rgba(213, 43, 30, 0.35)' : 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '2px',
          transition: 'all 0.15s ease',
          outline: 'none',
          WebkitAppearance: 'none'
        }
      }, m("span", {
        style: {
          fontWeight: 800,
          fontSize: '13px',
          lineHeight: 1.2
        }
      }, lvl.name), m("span", {
        style: {
          fontSize: '11px',
          opacity: isActive ? 0.95 : 0.7,
          fontWeight: 600
        }
      }, lvl.desc));
    })));
  }
  renderStartScreen() {
    const descriptions = {
      1: 'Descubre los 5 leones del Primer Equipo Masculino. Cuentas con pistas de posición, dorsal y la primera letra ya colocada.',
      2: 'Descubre los 5 leones del Primer Equipo Masculino y Femenino. Sin pistas iniciales (puedes solicitar pista de posición o dorsal si te atascas).',
      3: 'El reto para los más entendidos: jugadores y leyendas formados en Lezama, Bilbao Athletic y cantera zurigorri.'
    };
    return m("div", {
      className: "anagrams-container"
    }, this.renderLevelSelector(), m("div", {
      className: "anagrams-start-card",
      style: {
        textAlign: 'center',
        padding: '24px 10px',
        maxWidth: '520px',
        margin: '0 auto'
      }
    }, m("div", {
      className: "start-icon",
      style: {
        fontSize: '44px',
        marginBottom: '12px',
        lineHeight: 1
      }
    }, "\uD83E\uDD81"), m("h3", {
      style: {
        fontSize: '22px',
        fontWeight: 800,
        color: '#1e293b',
        margin: '0 0 10px 0'
      }
    }, "Anagramas Zurigorris \u2014 Nivel ", this.level), m("p", {
      className: "start-desc",
      style: {
        fontSize: '14px',
        color: '#64748b',
        marginBottom: '22px',
        lineHeight: 1.5
      }
    }, descriptions[this.level] || descriptions[1]), m("div", {
      className: "start-rules-box",
      style: {
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '26px',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }
    }, m("div", {
      className: "rule-item",
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontSize: '13px',
        color: '#334155',
        lineHeight: '1.4'
      }
    }, m("i", {
      className: "fas fa-cubes",
      style: {
        color: '#d52b1e',
        fontSize: '16px',
        width: '20px',
        textAlign: 'center',
        flexShrink: 0
      }
    }), m("span", null, m("strong", null, "5 Leones"), " a 200 pts por acierto (hasta ", m("strong", null, "1.000 pts tope"), ").")), m("div", {
      className: "rule-item",
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontSize: '13px',
        color: '#334155',
        lineHeight: '1.4'
      }
    }, m("i", {
      className: "fas fa-stopwatch",
      style: {
        color: '#d52b1e',
        fontSize: '16px',
        width: '20px',
        textAlign: 'center',
        flexShrink: 0
      }
    }), m("span", null, m("strong", null, "El tiempo resta:"), " tras 10s de cortes\xEDa, cada segundo resta ", m("strong", null, "2 puntos"), ".")), m("div", {
      className: "rule-item",
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontSize: '13px',
        color: '#334155',
        lineHeight: '1.4'
      }
    }, m("i", {
      className: "fas fa-forward",
      style: {
        color: '#d52b1e',
        fontSize: '16px',
        width: '20px',
        textAlign: 'center',
        flexShrink: 0
      }
    }), m("span", null, m("strong", null, "Pasa cuando quieras:"), " pulsa \xABPasar\xBB para alternar de le\xF3n y resolverlos en el orden que prefieras.")), m("div", {
      className: "rule-item",
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontSize: '13px',
        color: '#334155',
        lineHeight: '1.4'
      }
    }, m("i", {
      className: "fas fa-trophy",
      style: {
        color: '#d52b1e',
        fontSize: '16px',
        width: '20px',
        textAlign: 'center',
        flexShrink: 0
      }
    }), m("span", null, m("strong", null, "Hasta 1.000 pts"), " para tu r\xE9cord personal y la clasificaci\xF3n general."))), m("button", {
      className: "btn-start-round",
      onclick: () => this.startGame(),
      style: {
        background: 'linear-gradient(135deg, #d52b1e 0%, #b91c1c 100%)',
        color: '#ffffff',
        border: 'none',
        padding: '14px 36px',
        borderRadius: '30px',
        fontSize: '17px',
        fontWeight: 800,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        boxShadow: '0 4px 14px rgba(213, 43, 30, 0.4)',
        outline: 'none',
        WebkitAppearance: 'none',
        width: '100%',
        maxWidth: '300px',
        margin: '0 auto',
        transition: 'all 0.2s ease'
      }
    }, m("i", {
      className: "fas fa-play"
    }), " \xA1Empezar Tanda!")));
  }
  view() {
    try {
      if (this.loading || this.submitting) {
        return m("div", {
          className: "anagrams-container loading-state",
          style: {
            textAlign: 'center',
            padding: '40px 20px'
          }
        }, m(LoadingIndicator, null), m("p", {
          style: {
            marginTop: '14px',
            fontWeight: 700,
            color: '#d52b1e'
          }
        }, this.submitting ? '🦁 Comprobando tus respuestas y guardando puntuación...' : 'Cargando leones zurigorris...'), this.submitting && m("div", {
          style: {
            marginTop: '16px'
          }
        }, m("button", {
          type: "button",
          className: "Button Button--link",
          style: {
            fontSize: '13px',
            color: '#64748b',
            textDecoration: 'underline'
          },
          onclick: () => {
            this.submitting = false;
            m.redraw();
          }
        }, "\xBFTarda demasiado? Volver a la partida")));
      }
      if (this.isFinished && this.results) {
        return this.renderResults();
      }
      if (!this.hasStarted) {
        return this.renderStartScreen();
      }
      const word = this.words[this.currentIndex];
      const state = this.wordStates[this.currentIndex];
      if (!word || !state) return null;
      const scrambledChars = word.scrambled.split('');
      const pattern = word.pattern || '';
      const firstLetterSlot = pattern.indexOf('_');
      const isCurrentFilled = this.isWordFilled(this.currentIndex);
      const allFilled = this.countIncompleteWords() === 0;
      return m("div", {
        className: "anagrams-container"
      }, !app.session.user && m("div", {
        className: "guest-notice-banner"
      }, m("div", null, m("i", {
        className: "fas fa-user-clock"
      }), " ", m("strong", null, "Modo Invitado:"), " Est\xE1s jugando sin iniciar sesi\xF3n. Tu partida no se guardar\xE1 en las clasificaciones."), m("a", {
        onclick: () => app.modal.show(LogInModal)
      }, "Iniciar Sesi\xF3n ", m("i", {
        className: "fas fa-sign-in-alt"
      }))), this.renderLevelSelector(), m("div", {
        className: "round-stepper",
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '6px',
          marginBottom: '16px',
          flexWrap: 'nowrap'
        }
      }, this.words.map((w, idx) => {
        var _this$wordStates$idx;
        const isCurrent = idx === this.currentIndex;
        const isCompleted = this.isWordCompleted(idx);
        const isSkipped = !isCompleted && Boolean((_this$wordStates$idx = this.wordStates[idx]) == null ? void 0 : _this$wordStates$idx.skipped);
        const statusClass = isCompleted ? 'filled' : isSkipped ? 'skipped' : 'pending';
        const statusTitle = isCompleted ? 'Completado' : isSkipped ? 'Pasado (pendiente)' : 'Pendiente';
        return m("button", {
          key: idx,
          className: "stepper-pill ".concat(isCurrent ? 'active' : '', " ").concat(statusClass),
          onclick: () => this.goToWord(idx),
          title: "Le\xF3n ".concat(idx + 1, ": ").concat(statusTitle),
          style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px',
            padding: '6px 10px',
            minWidth: '46px',
            borderRadius: '20px',
            border: isCurrent ? '2px solid #d52b1e' : isCompleted ? '1px solid #86efac' : isSkipped ? '1px solid #fcd34d' : '1px solid #cbd5e1',
            background: isCurrent ? '#d52b1e' : isCompleted ? '#f0fdf4' : isSkipped ? '#fffbeb' : '#f8fafc',
            color: isCurrent ? '#ffffff' : isCompleted ? '#166534' : isSkipped ? '#b45309' : '#475569',
            fontSize: '13px',
            fontWeight: '700',
            cursor: 'pointer',
            outline: 'none',
            WebkitAppearance: 'none',
            boxShadow: isCurrent ? '0 2px 8px rgba(213, 43, 30, 0.3)' : 'none',
            transition: 'all 0.15s ease'
          }
        }, m("span", {
          className: "stepper-prefix-desktop"
        }, "Le\xF3n "), m("span", null, idx + 1), isCompleted ? m("i", {
          className: "fas fa-check"
        }) : isSkipped ? m("i", {
          className: "fas fa-redo"
        }) : m("i", {
          className: "far fa-circle"
        }));
      })), m("div", {
        className: "game-status-bar"
      }, m("div", null, "Le\xF3n ", m("strong", null, this.currentIndex + 1), " de ", this.words.length), m("div", {
        className: "timer-box"
      }, m("i", {
        className: "fas fa-stopwatch"
      }), " ", this.formatTime(this.timerSeconds)), m("div", null, "Equipo: ", m("strong", null, word.team_name))), m("div", {
        className: "game-notice-bar"
      }, m("i", {
        className: "fas fa-info-circle"
      }), " Resuelve los leones en el orden que prefieras o pulsa ", m("strong", null, "\xABPasar\xBB"), " para volver luego. Los aciertos y tu puntuaci\xF3n se revelar\xE1n al finalizar la tanda completa."), m("div", {
        className: "word-play-area"
      }, this.level === 1 && m("div", {
        className: "player-clue-badge"
      }, word.position && m("span", null, "Posici\xF3n: ", m("strong", null, word.position)), word.number && m("span", null, " \u2022 Dorsal: ", m("strong", null, "#", word.number)), word.first_letter && m("span", null, " \u2022 Empieza por: ", m("strong", null, word.first_letter))), (this.level === 2 || this.level === 3) && state.hintRevealed && m("div", {
        className: "player-clue-badge"
      }, word.position_hint && m("span", null, "Posici\xF3n: ", m("strong", null, word.position_hint)), word.number_hint && m("span", null, " \u2022 Dorsal: ", m("strong", null, "#", word.number_hint))), m("div", {
        className: "answer-slots-wrapper"
      }, state.placedLetters.map((char, sIdx) => {
        const isSpace = pattern[sIdx] === ' ';
        if (isSpace) {
          return m("div", {
            key: sIdx,
            className: "answer-slot slot-space"
          }, "\xA0");
        }
        const isHint = this.level === 1 && sIdx === firstLetterSlot && Boolean(word.first_letter);
        return m("div", {
          key: sIdx,
          className: "answer-slot ".concat(char ? 'filled' : '', " ").concat(isHint ? 'is-hint' : ''),
          onclick: () => this.handleSlotClick(sIdx),
          title: char ? 'Click para quitar letra' : ''
        }, char);
      })), m("div", {
        className: "letter-tiles-wrapper"
      }, scrambledChars.map((letter, tIdx) => {
        const isUsed = state.usedTileIndices.includes(tIdx);
        return m("button", {
          key: tIdx,
          className: "letter-tile ".concat(isUsed ? 'used' : ''),
          disabled: isUsed,
          onclick: () => this.handleTileClick(letter, tIdx)
        }, letter);
      })), m("div", {
        className: "game-controls"
      }, m("button", {
        className: "btn-game btn-clear",
        onclick: () => this.resetCurrentWord()
      }, m("i", {
        className: "fas fa-undo"
      }), " Reiniciar"), (this.level === 2 || this.level === 3) && !state.hintRevealed && m("button", {
        className: "btn-game btn-hint",
        onclick: () => this.revealHint(),
        title: "Muestra posici\xF3n del jugador (-30 pts)"
      }, m("i", {
        className: "fas fa-lightbulb"
      }), " Pedir Pista (-30 pts)"), m("button", {
        className: "btn-game btn-skip",
        onclick: () => this.skipCurrentWord(),
        title: "Pasa al siguiente le\xF3n y vuelve a este m\xE1s tarde"
      }, m("i", {
        className: "fas fa-forward"
      }), " Pasar (volver luego)"), m("button", {
        className: "btn-game ".concat(allFilled ? 'btn-finish-direct' : 'btn-submit'),
        onclick: () => this.promptFinishRound()
      }, m("i", {
        className: "fas fa-flag-checkered"
      }), " Finalizar Tanda"))));
    } catch (viewErr) {
      console.error('[AnagramasGame] FATAL CRASH IN VIEW():', viewErr);
      return m("div", {
        className: "anagrams-container error-state",
        style: {
          padding: '30px',
          color: '#b91c1c'
        }
      }, m("h3", null, "Error al renderizar el juego:"), m("pre", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, String((viewErr == null ? void 0 : viewErr.stack) || (viewErr == null ? void 0 : viewErr.message) || viewErr)));
    }
  }
  renderResults() {
    try {
      var _res$score, _res$correct_count, _ref, _res$total_words, _res$base_points, _res$time_penalty, _res$hint_penalty, _ref2, _res$duration_seconds;
      const res = this.results || {};
      const score = Number((_res$score = res.score) != null ? _res$score : 0);
      const correctCount = Number((_res$correct_count = res.correct_count) != null ? _res$correct_count : 0);
      const totalWords = Number((_ref = (_res$total_words = res.total_words) != null ? _res$total_words : this.words.length) != null ? _ref : 5);
      const basePoints = Number((_res$base_points = res.base_points) != null ? _res$base_points : correctCount * 200);
      const timePenalty = Number((_res$time_penalty = res.time_penalty) != null ? _res$time_penalty : 0);
      const hintPenalty = Number((_res$hint_penalty = res.hint_penalty) != null ? _res$hint_penalty : 0);
      const durationSeconds = Number((_ref2 = (_res$duration_seconds = res.duration_seconds) != null ? _res$duration_seconds : this.timerSeconds) != null ? _ref2 : 0);
      const resultsList = Array.isArray(res.results) ? res.results : [];
      return m("div", {
        className: "anagrams-container"
      }, m("div", {
        className: "round-results-card"
      }, m("div", {
        className: "results-title"
      }, score >= 800 ? '🦁 ¡Bikain! ¡Gran actuación zurigorri!' : '👏 ¡Tanda Completada!'), m("div", {
        className: "results-score-big"
      }, score, " ", m("span", {
        style: {
          fontSize: '20px',
          color: '#64748b'
        }
      }, "/ 1.000 pts")), app.session.user ? m("div", {
        className: "saved-score-pill success"
      }, m("i", {
        className: "fas fa-check-circle"
      }), " Puntuaci\xF3n guardada con \xE9xito en tu perfil y clasificaciones.", res.is_new_record && m("strong", null, " \u2014 \xA1Nuevo R\xE9cord Personal! \uD83C\uDFC6")) : m("div", {
        className: "saved-score-pill warning"
      }, m("i", {
        className: "fas fa-exclamation-triangle"
      }), " ", m("strong", null, "Puntuaci\xF3n no registrada:"), " Has jugado como invitado.", ' ', m("a", {
        onclick: () => app.modal.show(LogInModal)
      }, "Inicia sesi\xF3n aqu\xED"), " para que tus puntuaciones se guarden en el ranking oficial de Aurrera Athletic y desbloqueen logros."), m("div", {
        className: "score-breakdown-table"
      }, m("div", {
        className: "breakdown-row"
      }, m("span", null, "Aciertos (", correctCount, "/", totalWords, ")"), m("span", null, "+", basePoints, " pts")), timePenalty > 0 ? m("div", {
        className: "breakdown-row"
      }, m("span", null, "Penalizaci\xF3n Tiempo (", durationSeconds, "s)"), m("span", {
        style: {
          color: '#dc2626'
        }
      }, "-", timePenalty, " pts")) : m("div", {
        className: "breakdown-row"
      }, m("span", null, "Tiempo (", durationSeconds, "s)"), m("span", {
        style: {
          color: '#16a34a'
        }
      }, "0 pts (sin penalizaci\xF3n)")), hintPenalty > 0 && m("div", {
        className: "breakdown-row"
      }, m("span", null, "Penalizaci\xF3n por Pistas"), m("span", {
        style: {
          color: '#dc2626'
        }
      }, "-", hintPenalty, " pts")), m("div", {
        className: "breakdown-row",
        style: {
          fontWeight: 800,
          borderTop: '2px solid #cbd5e1',
          paddingTop: '8px'
        }
      }, m("span", null, "Puntuaci\xF3n para el Ranking"), m("span", null, score, " pts"))), resultsList.length > 0 && m("div", {
        className: "words-review-list"
      }, m("h4", {
        style: {
          marginBottom: '12px'
        }
      }, "Soluciones de la tanda:"), resultsList.map((item, idx) => m("div", {
        key: idx,
        className: "word-review-item ".concat(item.is_correct ? 'correct' : 'incorrect')
      }, m("div", null, m("i", {
        className: item.is_correct ? 'fas fa-check-circle' : 'fas fa-times-circle'
      }), ' ', m("strong", null, item.display_name), " (", item.target_word, ")"), m("div", {
        style: {
          fontSize: '13px'
        }
      }, "Tu respuesta: ", m("em", null, item.user_answer || '(en blanco)'))))), m("div", {
        className: "results-leaderboard-box",
        style: {
          marginTop: '24px',
          textAlign: 'left'
        }
      }, m("h4", {
        style: {
          marginBottom: '12px',
          fontSize: '15px',
          fontWeight: 800,
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }
      }, m("i", {
        className: "fas fa-trophy",
        style: {
          color: '#d52b1e'
        }
      }), " Clasificaci\xF3n de este Nivel (", this.level, "):"), m(PasatiemposLeaderboard, {
        initialFilter: "anagrams_".concat(this.level),
        hideFilters: true,
        compact: true
      })), m("div", {
        className: "results-actions",
        style: {
          marginTop: '24px'
        }
      }, m(Button, {
        className: "Button Button--primary",
        icon: "fas fa-redo",
        onclick: () => this.startNewRound(this.level)
      }, "Jugar otra vez este nivel"), m(Button, {
        className: "Button btn-outline-red",
        style: {
          background: '#fff',
          color: '#d52b1e',
          borderColor: '#d52b1e',
          borderWidth: '1.5px',
          borderStyle: 'solid',
          fontWeight: 700
        },
        icon: this.level < 3 ? 'fas fa-arrow-right' : 'fas fa-redo',
        onclick: () => this.startNewRound(this.level < 3 ? this.level + 1 : 1)
      }, this.level < 3 ? "Probar Nivel ".concat(this.level + 1) : 'Volver a Nivel 1'), m(Button, {
        className: "Button Button--link",
        style: {
          color: '#64748b',
          fontWeight: 600
        },
        icon: "fas fa-medal",
        onclick: () => {
          var _this$attrs;
          if ((_this$attrs = this.attrs) != null && _this$attrs.onNavigateTab) {
            this.attrs.onNavigateTab('leaderboard');
          } else {
            m.route.set('/pasatiempos/clasificacion');
          }
        }
      }, "Ver Clasificaciones Generales"))));
    } catch (resErr) {
      console.error('[AnagramasGame] FATAL CRASH IN RENDERRESULTS():', resErr);
      return m("div", {
        className: "anagrams-container error-state",
        style: {
          padding: '30px',
          color: '#b91c1c'
        }
      }, m("h3", null, "Error al renderizar los resultados:"), m("pre", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, String((resErr == null ? void 0 : resErr.stack) || (resErr == null ? void 0 : resErr.message) || resErr)));
    }
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/pasatiempos/AnagramasGame', AnagramasGame);